import React from "react";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { PaymentReminderConfigProvider } from "../context/PaymentReminderConfig.context";
import { usePaymentReminderConfig } from "../context/PaymentReminderConfig.context";
import { IPaymentReminderConfigForm } from "../types/paymentReminderConfig.types";
import { Step1DetailsAndRule } from "./Step1DetailsAndRule";
import { Step2TemplateAndVariables } from "./Step2TemplateAndVariables";
import { Step3CronScheduler } from "./Step3CronScheduler";

const STEPS = ["Campaign & Rule Config", "Template & Variables", "Schedule"];

interface PaymentReminderConfigWizardProps {
  mode: "page" | "dialog";
  initialData?: IPaymentReminderConfigForm | null;
  onSuccess?: () => void;
  onCancel?: () => void;
}

/**
 * Inner wizard content — consumes context
 */
const WizardContent: React.FC = () => {
  const { activeStep } = usePaymentReminderConfig();

  return (
    <Box>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
        {STEPS.map((label, index) => (
          <Step key={label} completed={index < activeStep}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && <Step1DetailsAndRule />}
      {activeStep === 1 && <Step2TemplateAndVariables />}
      {activeStep === 2 && <Step3CronScheduler />}
    </Box>
  );
};

/**
 * PaymentReminderConfigWizard
 * Reusable 3-step wizard that works in both full-page and dialog modes.
 * Wraps its content in the PaymentReminderConfigProvider.
 */
export const PaymentReminderConfigWizard: React.FC<
  PaymentReminderConfigWizardProps
> = ({ mode, initialData, onSuccess, onCancel }) => {
  return (
    <PaymentReminderConfigProvider
      mode={mode}
      initialData={initialData}
      onSuccess={onSuccess}
    >
      <WizardContent />
    </PaymentReminderConfigProvider>
  );
};
